import { toggleBottomLogo, getElem, pause, toggleBgWithText, logEvent } from "../utils";

const filename = 'lion-recorded-video.mp4';

class HTML_SaveShare {
    private html = {
        saveshare: getElem("saveshare"),
        container: getElem("saveshare-container"),
        closeButton: getElem("saveshare-closeButton"),
        shareButton: getElem("saveshare-shareButton"),
        videoNode: getElem("saveshare-videoNode") as HTMLVideoElement,
    };
    
    constructor() {
        this.html.videoNode.loop = true;
        this.html.shareButton.addEventListener('click', () => {
            this.downloadVideo();
        });
        this.html.closeButton.addEventListener("pointerup", () => {
            this.deactivate();
        });
    }
    
    public async activate(blob: Blob, onClose: () => void) {
        this.html.closeButton.addEventListener("pointerup", onClose);
        this.html.closeButton.addEventListener("pointerup", () => {
            logEvent("close_button_click");
            this.html.closeButton.removeEventListener("pointerup", onClose);
        });

        console.log("show saveshare")
        toggleBottomLogo(true, "70px");
        toggleBgWithText(true);
        console.log(this.html.saveshare)
        this.html.saveshare.style.display = 'flex';

        this.insertVideo(blob);

        await pause(200);
        this.html.saveshare.style.opacity = '1';
    }

    private blob: Blob | null = null;
    private insertVideo(blob: Blob) {
        this.blob = blob;
        console.log('Showing download prompt for blob:', this.blob, 'Size:', this.blob.size);
        const blobUrl = URL.createObjectURL(this.blob);
        this.html.videoNode.src = blobUrl;
        this.html.videoNode.play();

    }

    // saveVideo() {
    //     if (!this.blob) {
    //         console.error('No video blob available to download');
    //         return false;
    //     }
        
    //     const url = window.URL.createObjectURL(this.blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = filename;
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //     document.body.removeChild(a);
    // }

    downloadVideo() {
        if (!this.blob) {
            console.error('No video blob available to download');
            return false;
        }
        
        console.log('Downloading video blob:', this.blob, 'Size:', this.blob.size);
        
        if (!navigator.canShare) {
            console.log('navigator.share() not available')
            return
        }

        navigator.share({
            files:[new File(
                [this.blob],
                filename,
                {type:"video/mp4"}
            )]
        });      

        // Clean up after a short delay
        // setTimeout(() => {
        //     document.body.removeChild(a);
        //     URL.revokeObjectURL(url);
        // }, 100);
        
        return true;
    }
    
    public async deactivate() {
        this.blob = null;
        toggleBottomLogo(false);
        toggleBgWithText(false);
        console.log(this.html.saveshare);
        this.html.saveshare.style.opacity = '0';
        await pause(500);
        this.html.saveshare.style.display = 'none';
        this.html.videoNode.pause();
        this.html.videoNode.removeAttribute('src');
        this.html.videoNode.load();
    }
}

export default HTML_SaveShare;